import React, { useContext } from 'react'
import { CartContext } from "src/context/CartContext"
import { Check } from "react-feather"
import classnames from "classnames"

import Button from "src/components/core/atoms/button"

import {
  listItem,
  miniHeading,
  setDefault
} from "./styles.module.css"

const dateTimeFormatOptions = {
  year: 'numeric', month: 'numeric', day: 'numeric',
  hour: 'numeric', minute: 'numeric',
  hour12: true,
}

export const Option = ( { value, data, args, onChange, setIsOpen } ) => {
  const handleItemClick = ( e ) => {
    if ( e.target === e.currentTarget ) {
      onChange( e, [ data[ 0 ], args ] )
      setIsOpen( false )
    }
  }

  const { dispatchLocations, dispatchDateTimes, ACTIONS } = useContext( CartContext )

  let date = !data[ 1 ].nickname && new Intl.DateTimeFormat( 'en-GB', dateTimeFormatOptions ).format( data[ 1 ] )

  return (
    <div
      className={ listItem }
      key={ data[ 0 ] }
      role="listitem"
      onClick={ handleItemClick }
    >
      { data[ 1 ]?.nickname || date }&nbsp;
      { ( value === data[ 0 ] ) && <Check size={ 12 } /> }&nbsp;
      { ( !date ) && (
        <span className={ classnames( miniHeading, { [ setDefault ]: ( data[ 0 ] !== "default_location" ) } ) }>(
          { data[ 0 ] === "default_location"
            ? "default"
            : <Button
              variant="underlined"
              size="small"
              onClick={ ( e ) => {
                dispatchLocations( { type: ACTIONS.SET_THE_DEFAULT, payload: data } )
                setIsOpen( false )
              } }
            >
              set as default?
                  </Button>
          }
        )</span>
      ) }
      { date && (
        <span className={ classnames( miniHeading, { [ setDefault ]: ( data[ 0 ] !== "default_dateTime" ) } ) }>(
          { data[ 0 ] === "default_dateTime"
            ? "default"
            : <Button
              variant="underlined"
              size="small"
              onClick={ ( e ) => {
                dispatchDateTimes( { type: ACTIONS.SET_THE_DEFAULT, payload: { date: data[ 1 ] } } )
                setIsOpen( false )
              } }
            >
              set as default?
                  </Button>
          }
        )</span>
      ) }
    </div>
  )
}

export default Option